<script>
export default {
    name: "Modal",
    props: {
        show: Boolean,
        dimension: String
    },
}
</script>
<template>
  <div class="modal is-active" style="z-index:50" v-if="show">
      <div class="modal-background" ></div>
      <div class="modal-card rounded" :class="dimension ? dimension : `h-64`">
        <header class="modal-card-head  bg-gray-300 p-3">
          <slot name="title"></slot>
        </header>
        <section class="modal-card-body bg-blue-100">
          <slot name="modal-body"></slot>
        </section>
        <footer class="modal-card-foot flex justify-end bg-gray-300 p-1">
          <slot name="modal-footer"></slot>
        </footer>
      </div>
  </div>
</template>

